import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { ListColumn } from 'src/app/models/list-column.model';

@Component({
  selector: 'app-work-experience-profile',
  templateUrl: './work-experience-profile.component.html',
  styleUrls: ['./work-experience-profile.component.scss']
})
export class WorkExperienceProfileComponent implements OnInit{
  @Input() value: boolean | undefined;
  minToDate: Date | undefined;

onFromDateChange(event: any) {
    this.minToDate = event.value;
}

  handleWorkExperience(clickedWorkExperience: boolean) {
    
  }

  workExpColumns: ListColumn[] = [
    { name: 'Designation', property: 'designation', visible: true, isModelProperty: true ,isText: true},
    {name:'From',property:'fromDate',visible:true,isModelProperty:true,isDatePipe:true},
    {name:'To',property:'toDate',visible:true,isModelProperty:true,isDatePipe:true},
    { name: 'Organization', property: 'organization', visible: true, isModelProperty: true ,isText: true},
    { name: 'Location', property: 'location', visible: true, isModelProperty: true ,isText: true},
  ] as ListColumn[];

  @Input() workExperienceForm!:FormGroup;
  @Input() endCustomerData:any;
  showEditForm:boolean=false;
  copyWorkExperienceForm:any;
  data:any=[];

  @Output() onUpdate:EventEmitter<any>=new EventEmitter();

  yearDropdown:any=[];
  futureYearDropdown:any=[];
  hospitalIcon:string="assets/images/hospital.svg";

  constructor(private fb :FormBuilder ){}
  ngOnInit(): void {
    this.data=JSON.parse(JSON.stringify( this.workExperienceForm.get('workInfos')?.value));
    this.applyValidators();
    this.getYearDropdown();
    this.getFutureYearDropdown();
  }
  applyValidators(): void {
    const designationValidators = [
      Validators.pattern(/^[A-Za-z\s]+$/),
      Validators.maxLength(50)
    ];

    const organizationValidators = [
      Validators.pattern(/^[A-Za-z0-9\s&.]+$/),
      Validators.maxLength(150)
    ];

    const locationValidators = [
      Validators.pattern(/^[A-Za-z0-9\s.,\-/#&]+$/),
      Validators.maxLength(50)
    ];

    if (this.workInfos && this.workInfos.controls.length) {
      this.workInfos.controls.forEach((control) => {
        const workControl = control as FormGroup;
        workControl.get('designation')?.setValidators(designationValidators);
        workControl.get('organization')?.setValidators(organizationValidators);
        workControl.get('location')?.setValidators(locationValidators);

        workControl.get('designation')?.updateValueAndValidity();
        workControl.get('organization')?.updateValueAndValidity();
        workControl.get('location')?.updateValueAndValidity();
      });
    }
  }
  getYearDropdown(){
    for(let year=new Date().getFullYear();year>=1947;year--){
      this.yearDropdown.push(year);
    }
  }

  getFutureYearDropdown(){
    for(let year=new Date().getFullYear()+5;year>=1947;year--){
      this.futureYearDropdown.push(year);
    }
  }

  get workInfos() {
    return this.workExperienceForm?.controls["workInfos"] as FormArray;
  }

  addFirstWork(){
    this.workInfos.push(
      this.fb.group({
        id:new FormControl(null),
        active:new FormControl(null),
        createdBy:new FormControl(null),
        createdOn:new FormControl(null),
        modifiedBy:new FormControl(null),
        modifiedOn:new FormControl(null),
       "designation": new FormControl(null),
        "fromDate":new FormControl(null),
        "toDate":new FormControl(null),
        "organization": new FormControl(null),
        "location": new FormControl(null),
       }),
    )
    this.applyValidators();  
    this.showEditForm=true;
  }
  addWork(){
    const lastWorkInfo = this.workInfos.at(this.workInfos.length - 1);
    const isLastWorkInfoFilled = Object.values(lastWorkInfo.value).some(value => value !== null && value !== '');
    if (isLastWorkInfoFilled) {
      this.copyWorkExperienceForm=JSON.parse(JSON.stringify(this.workExperienceForm.value));
      this.workInfos.push(
        this.fb.group({
          id:new FormControl(null),
          active:new FormControl(null),
          createdBy:new FormControl(null),
          createdOn:new FormControl(null),
          modifiedBy:new FormControl(null),
          modifiedOn:new FormControl(null),
         "designation": new FormControl(null),
          "fromDate":new FormControl(null),
          "toDate":new FormControl(null),
          "organization": new FormControl(null),
          "location": new FormControl(null),
         }),
      )
      this.applyValidators(); 
      this.showEditForm=true;
    }
  }

  editWork(){
    this.copyWorkExperienceForm=JSON.parse(JSON.stringify(this.workExperienceForm.value));
    this.showEditForm=true;
  }
  
  update(){
    this.workInfos.markAllAsTouched();
    this.applyValidators();
    if(this.workInfos.invalid){
      return;
    }
    this.onUpdate.emit(40);
  }
  
  refresh(){
    this.showEditForm=false;
    this.data=JSON.parse(JSON.stringify( this.workExperienceForm.get('workInfos')?.value));
  }
  
  cancel(){
      
    (this.workExperienceForm.get('workInfos')as FormArray).clear();
     if(this.copyWorkExperienceForm?.workInfos && this.copyWorkExperienceForm.workInfos.length>0){
          for(let i=0;i<this.copyWorkExperienceForm.workInfos.length;i++){
            if(this.copyWorkExperienceForm.workInfos[i].designation || this.copyWorkExperienceForm.workInfos[i].fromDate || this.copyWorkExperienceForm.workInfos[i].toDate || this.copyWorkExperienceForm.workInfos[i].organization || this.copyWorkExperienceForm.workInfos[i].location){
              (this.workExperienceForm.get('workInfos')as FormArray).push( this.fb.group({
                id:new FormControl(null),
                active:new FormControl(null),
                createdBy:new FormControl(null),
                createdOn:new FormControl(null),
                modifiedBy:new FormControl(null),
                modifiedOn:new FormControl(null),
                "designation"  :new FormControl(this.copyWorkExperienceForm.workInfos[i].designation,[Validators.required, Validators.maxLength(50)]),
                "fromDate":new FormControl(this.copyWorkExperienceForm.workInfos[i].fromDate),
                "toDate":new FormControl(this.copyWorkExperienceForm.workInfos[i].toDate),
                "organization": new FormControl(this.copyWorkExperienceForm.workInfos[i].organization),
                "location": new FormControl(this.copyWorkExperienceForm.workInfos[i].location),
              }));
            }
          }
          
        }

       
    this.showEditForm=false;
    this.data=JSON.parse(JSON.stringify( this.workExperienceForm.get('workInfos')?.value));
  
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }

  
  deleteWork(i:number){
  this.workInfos.removeAt(i);
  }
}
